module.exports = __webpack_public_path__ + "img/bx_bx-minus-circle.ae0ae26a.svg";